import { render, staticRenderFns } from "./StandardPagination.vue?vue&type=template&id=5b013779&scoped=true"
import script from "./StandardPagination.vue?vue&type=script&lang=js"
export * from "./StandardPagination.vue?vue&type=script&lang=js"
import style0 from "./StandardPagination.vue?vue&type=style&index=0&id=5b013779&prod&lang=css"
import style1 from "./StandardPagination.vue?vue&type=style&index=1&id=5b013779&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b013779",
  null
  
)

export default component.exports